<template>
  <div :class="ns.b()">
    <div :class="ns.e('left')">
      <template v-if="reactData.editStr === ''">
        <z-button
          v-if="showNewBtn"
          :icon="CirclePlusFilled"
          type="primary"
          @click="$grid.handleInsert?.()"
        >
          {{ t('z.table.toolbar.add') }}
        </z-button>
        <z-button
          v-if="showNewChildBtn"
          :icon="CirclePlusFilled"
          type="primary"
          plain
          @click="$grid.handleInsertChild?.()"
        >
          新增子节点
        </z-button>
        <z-button
          v-if="showDelBtn"
          :icon="Delete"
          type="warning"
          @click="$grid.handleDeleteRows?.()"
        >
          {{ t('z.table.toolbar.delete') }}
        </z-button>
      </template>
      <template v-else-if="tableEditable">
        <z-button :icon="Finished" type="primary" @click="$grid.saveData?.()">
          {{ t('z.table.toolbar.save') }}
        </z-button>
        <z-button :icon="Finished" type="warning" @click="$grid.queryByExamplePage()">
          {{ t('z.table.toolbar.cancel') }}
        </z-button>
      </template>
    </div>
    <div :class="ns.e('right')">
      <z-button link :icon="Refresh" @click="$grid.queryByExamplePage()">
        {{ t('z.table.toolbar.refresh') }}
      </z-button>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, inject } from 'vue'
import ZButton from '@zoryn/components/button'
import { CirclePlusFilled, Delete, Finished, Refresh } from '@zoryn/icons'
import { useLocale, useNamespace } from '@zoryn/hooks'
import { resolveGridEditable } from '@zoryn/components/grid/src/column/meta'
import type { DataGridTree } from '../types'

const ns = useNamespace('grid-toolbar')
const { t } = useLocale()
const $grid = inject('$grid') as DataGridTree
const { reactData, options } = $grid

const tableEditable = computed(() => resolveGridEditable($grid.props, options))
const showNewBtn = computed(() => tableEditable.value && options.newBtn === true)
const showNewChildBtn = computed(() => tableEditable.value && options.newChildBtn === true)
const showDelBtn = computed(() => options.delBtn === true)
</script>
